const translations = {
  en: {
    // Nav
    appName: 'SeniorCare',
    hello: 'Hello',
    appointments: 'Appointments',
    settings: 'Settings',
    logout: 'Logout',
    notifications: 'Notifications',
    noNotifications: 'No notifications yet',
    markAllRead: 'Mark all read',
    clearAll: 'Clear all notifications',
    // Dashboard
    dashboard: 'Dashboard',
    addSenior: 'Add Senior',
    addCaregiver: 'Add Caregiver',
    seniors: 'Seniors',
    caregivers: 'Caregivers',
    totalSeniors: 'Total Seniors',
    totalCaregivers: 'Total Caregivers',
    totalMedications: 'Total Medications',
    todayAppointments: "Today's Appointments",
    name: 'Name',
    age: 'Age',
    phone: 'Phone',
    photo: 'Photo',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    view: 'View',
    close: 'Close',
    // Senior detail
    medications: 'Medications',
    vitals: 'Vitals',
    journal: 'Journal',
    addMedication: 'Add Medication',
    medicationName: 'Medication Name',
    dose: 'Dose',
    frequency: 'Frequency',
    time: 'Time',
    notes: 'Notes',
    logDose: 'Log Dose',
    sosAlert: 'SOS Alert',
    sendSos: 'Send SOS',
    pdfReport: 'PDF Report',
    emailReport: 'Email Report',
    bloodPressure: 'Blood Pressure',
    heartRate: 'Heart Rate',
    weight: 'Weight',
    glucose: 'Glucose',
    addVital: 'Add Vital',
    addJournalEntry: 'Add Journal Entry',
    journalEntry: 'Journal Entry',
    // Appointments
    allAppointments: 'All Appointments',
    upcoming: 'Upcoming',
    completed: 'Completed',
    addAppointment: 'Add Appointment',
    appointmentTitle: 'Title',
    appointmentDate: 'Date',
    appointmentTime: 'Time',
    appointmentType: 'Type',
    doctor: 'Doctor',
    bloodTest: 'Blood Test',
    checkup: 'Check-up',
    other: 'Other',
    recurring: 'Recurring',
    repeatEvery: 'Repeat Every',
    days: 'days',
    weeks: 'weeks',
    markComplete: 'Mark Complete',
    addResults: 'Add Results',
    results: 'Results',
    listView: 'List View',
    calendarView: 'Calendar View',
    // Assignments
    assignedCaregivers: 'Assigned Caregivers',
    assignCaregiver: 'Assign Caregiver',
    removeAssignment: 'Remove',
    noAssignments: 'No caregivers assigned yet',
    // Settings
    profile: 'Profile',
    fullName: 'Full Name',
    email: 'Email',
    saveProfile: 'Save Profile',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    subscription: 'Subscription',
    uploadPhoto: 'Upload Photo',
    changePhoto: 'Change Photo',
    removePhoto: 'Remove Photo',
    darkMode: 'Dark Mode',
    language: 'Language',
    appearance: 'Appearance & Language',
    // Messages
    success: 'Success',
    error: 'Error',
    loading: 'Loading...',
    saving: 'Saving...',
    deleting: 'Deleting...',
    confirmDelete: 'Are you sure you want to delete this?',
    profileUpdated: 'Profile updated successfully!',
    passwordChanged: 'Password changed successfully!',
    passwordMismatch: 'New passwords do not match',
    passwordShort: 'New password must be at least 12 characters',
  },

  ar: {
    appName: 'رعاية المسنين',
    hello: 'مرحباً',
    appointments: 'المواعيد',
    settings: 'الإعدادات',
    logout: 'تسجيل الخروج',
    notifications: 'الإشعارات',
    noNotifications: 'لا توجد إشعارات',
    markAllRead: 'تحديد الكل كمقروء',
    clearAll: 'مسح جميع الإشعارات',
    dashboard: 'لوحة التحكم',
    addSenior: 'إضافة مسن',
    addCaregiver: 'إضافة مقدم رعاية',
    seniors: 'المسنون',
    caregivers: 'مقدمو الرعاية',
    totalSeniors: 'إجمالي المسنين',
    totalCaregivers: 'إجمالي مقدمي الرعاية',
    totalMedications: 'إجمالي الأدوية',
    todayAppointments: 'مواعيد اليوم',
    name: 'الاسم',
    age: 'العمر',
    phone: 'الهاتف',
    photo: 'الصورة',
    edit: 'تعديل',
    delete: 'حذف',
    save: 'حفظ',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    view: 'عرض',
    close: 'إغلاق',
    medications: 'الأدوية',
    vitals: 'العلامات الحيوية',
    journal: 'السجل اليومي',
    addMedication: 'إضافة دواء',
    medicationName: 'اسم الدواء',
    dose: 'الجرعة',
    frequency: 'التكرار',
    time: 'الوقت',
    notes: 'ملاحظات',
    logDose: 'تسجيل الجرعة',
    sosAlert: 'تنبيه SOS',
    sendSos: 'إرسال SOS',
    pdfReport: 'تقرير PDF',
    emailReport: 'تقرير بريد إلكتروني',
    bloodPressure: 'ضغط الدم',
    heartRate: 'معدل ضربات القلب',
    weight: 'الوزن',
    glucose: 'السكر',
    addVital: 'إضافة قياس',
    addJournalEntry: 'إضافة ملاحظة',
    journalEntry: 'ملاحظة يومية',
    allAppointments: 'جميع المواعيد',
    upcoming: 'القادمة',
    completed: 'المكتملة',
    addAppointment: 'إضافة موعد',
    appointmentTitle: 'العنوان',
    appointmentDate: 'التاريخ',
    appointmentTime: 'الوقت',
    appointmentType: 'النوع',
    doctor: 'طبيب',
    bloodTest: 'تحليل دم',
    checkup: 'فحص دوري',
    other: 'أخرى',
    recurring: 'متكرر',
    repeatEvery: 'كرر كل',
    days: 'أيام',
    weeks: 'أسابيع',
    markComplete: 'تحديد كمكتمل',
    addResults: 'إضافة نتائج',
    results: 'النتائج',
    listView: 'قائمة',
    calendarView: 'تقويم',
    assignedCaregivers: 'مقدمو الرعاية المعينون',
    assignCaregiver: 'تعيين مقدم رعاية',
    removeAssignment: 'إزالة',
    noAssignments: 'لم يتم تعيين مقدمي رعاية بعد',
    profile: 'الملف الشخصي',
    fullName: 'الاسم الكامل',
    email: 'البريد الإلكتروني',
    saveProfile: 'حفظ الملف الشخصي',
    changePassword: 'تغيير كلمة المرور',
    currentPassword: 'كلمة المرور الحالية',
    newPassword: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور الجديدة',
    subscription: 'الاشتراك',
    uploadPhoto: 'رفع صورة',
    changePhoto: 'تغيير الصورة',
    removePhoto: 'إزالة الصورة',
    darkMode: 'الوضع الداكن',
    language: 'اللغة',
    appearance: 'المظهر واللغة',
    success: 'نجاح',
    error: 'خطأ',
    loading: 'جاري التحميل...',
    saving: 'جاري الحفظ...',
    deleting: 'جاري الحذف...',
    confirmDelete: 'هل أنت متأكد من الحذف؟',
    profileUpdated: 'تم تحديث الملف الشخصي بنجاح!',
    passwordChanged: 'تم تغيير كلمة المرور بنجاح!',
    passwordMismatch: 'كلمات المرور الجديدة غير متطابقة',
    passwordShort: 'كلمة المرور يجب أن تكون 12 حرفاً على الأقل',
  },

  fr: {
    appName: 'SeniorCare',
    hello: 'Bonjour',
    appointments: 'Rendez-vous',
    settings: 'Paramètres',
    logout: 'Déconnexion',
    notifications: 'Notifications',
    noNotifications: 'Aucune notification',
    markAllRead: 'Tout marquer comme lu',
    clearAll: 'Effacer toutes les notifications',
    dashboard: 'Tableau de bord',
    addSenior: 'Ajouter un senior',
    addCaregiver: 'Ajouter un aidant',
    seniors: 'Seniors',
    caregivers: 'Aidants',
    totalSeniors: 'Total seniors',
    totalCaregivers: 'Total aidants',
    totalMedications: 'Total médicaments',
    todayAppointments: "Rendez-vous aujourd'hui",
    name: 'Nom',
    age: 'Âge',
    phone: 'Téléphone',
    photo: 'Photo',
    edit: 'Modifier',
    delete: 'Supprimer',
    save: 'Enregistrer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    view: 'Voir',
    close: 'Fermer',
    medications: 'Médicaments',
    vitals: 'Signes vitaux',
    journal: 'Journal',
    addMedication: 'Ajouter médicament',
    medicationName: 'Nom du médicament',
    dose: 'Dose',
    frequency: 'Fréquence',
    time: 'Heure',
    notes: 'Notes',
    logDose: 'Enregistrer dose',
    sosAlert: 'Alerte SOS',
    sendSos: 'Envoyer SOS',
    pdfReport: 'Rapport PDF',
    emailReport: 'Rapport par email',
    bloodPressure: 'Tension artérielle',
    heartRate: 'Fréquence cardiaque',
    weight: 'Poids',
    glucose: 'Glycémie',
    addVital: 'Ajouter signe vital',
    addJournalEntry: 'Ajouter une note',
    journalEntry: 'Note quotidienne',
    allAppointments: 'Tous les rendez-vous',
    upcoming: 'À venir',
    completed: 'Terminés',
    addAppointment: 'Ajouter rendez-vous',
    appointmentTitle: 'Titre',
    appointmentDate: 'Date',
    appointmentTime: 'Heure',
    appointmentType: 'Type',
    doctor: 'Médecin',
    bloodTest: 'Prise de sang',
    checkup: 'Bilan de santé',
    other: 'Autre',
    recurring: 'Récurrent',
    repeatEvery: 'Répéter tous les',
    days: 'jours',
    weeks: 'semaines',
    markComplete: 'Marquer terminé',
    addResults: 'Ajouter résultats',
    results: 'Résultats',
    listView: 'Liste',
    calendarView: 'Calendrier',
    assignedCaregivers: 'Aidants assignés',
    assignCaregiver: 'Assigner un aidant',
    removeAssignment: 'Retirer',
    noAssignments: "Aucun aidant assigné pour l'instant",
    profile: 'Profil',
    fullName: 'Nom complet',
    email: 'Email',
    saveProfile: 'Enregistrer le profil',
    changePassword: 'Changer le mot de passe',
    currentPassword: 'Mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    confirmPassword: 'Confirmer le nouveau mot de passe',
    subscription: 'Abonnement',
    uploadPhoto: 'Télécharger photo',
    changePhoto: 'Changer photo',
    removePhoto: 'Supprimer photo',
    darkMode: 'Mode sombre',
    language: 'Langue',
    appearance: 'Apparence et langue',
    success: 'Succès',
    error: 'Erreur',
    loading: 'Chargement...',
    saving: 'Enregistrement...',
    deleting: 'Suppression...',
    confirmDelete: 'Voulez-vous vraiment supprimer ?',
    profileUpdated: 'Profil mis à jour avec succès !',
    passwordChanged: 'Mot de passe changé avec succès !',
    passwordMismatch: 'Les nouveaux mots de passe ne correspondent pas',
    passwordShort: 'Le mot de passe doit comporter au moins 12 caractères',
  },

  es: {
    appName: 'SeniorCare',
    hello: 'Hola',
    appointments: 'Citas',
    settings: 'Configuración',
    logout: 'Cerrar sesión',
    notifications: 'Notificaciones',
    noNotifications: 'Sin notificaciones',
    markAllRead: 'Marcar todo como leído',
    clearAll: 'Borrar todas las notificaciones',
    dashboard: 'Panel',
    addSenior: 'Agregar mayor',
    addCaregiver: 'Agregar cuidador',
    seniors: 'Mayores',
    caregivers: 'Cuidadores',
    totalSeniors: 'Total mayores',
    totalCaregivers: 'Total cuidadores',
    totalMedications: 'Total medicamentos',
    todayAppointments: 'Citas de hoy',
    name: 'Nombre',
    age: 'Edad',
    phone: 'Teléfono',
    photo: 'Foto',
    edit: 'Editar',
    delete: 'Eliminar',
    save: 'Guardar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    view: 'Ver',
    close: 'Cerrar',
    medications: 'Medicamentos',
    vitals: 'Signos vitales',
    journal: 'Diario',
    addMedication: 'Agregar medicamento',
    medicationName: 'Nombre del medicamento',
    dose: 'Dosis',
    frequency: 'Frecuencia',
    time: 'Hora',
    notes: 'Notas',
    logDose: 'Registrar dosis',
    sosAlert: 'Alerta SOS',
    sendSos: 'Enviar SOS',
    pdfReport: 'Informe PDF',
    emailReport: 'Informe por email',
    bloodPressure: 'Presión arterial',
    heartRate: 'Frecuencia cardíaca',
    weight: 'Peso',
    glucose: 'Glucosa',
    addVital: 'Agregar vital',
    addJournalEntry: 'Agregar nota',
    journalEntry: 'Nota diaria',
    allAppointments: 'Todas las citas',
    upcoming: 'Próximas',
    completed: 'Completadas',
    addAppointment: 'Agregar cita',
    appointmentTitle: 'Título',
    appointmentDate: 'Fecha',
    appointmentTime: 'Hora',
    appointmentType: 'Tipo',
    doctor: 'Médico',
    bloodTest: 'Análisis de sangre',
    checkup: 'Revisión',
    other: 'Otro',
    recurring: 'Recurrente',
    repeatEvery: 'Repetir cada',
    days: 'días',
    weeks: 'semanas',
    markComplete: 'Marcar completo',
    addResults: 'Agregar resultados',
    results: 'Resultados',
    listView: 'Lista',
    calendarView: 'Calendario',
    assignedCaregivers: 'Cuidadores asignados',
    assignCaregiver: 'Asignar cuidador',
    removeAssignment: 'Retirar',
    noAssignments: 'Sin cuidadores asignados',
    profile: 'Perfil',
    fullName: 'Nombre completo',
    email: 'Correo electrónico',
    saveProfile: 'Guardar perfil',
    changePassword: 'Cambiar contraseña',
    currentPassword: 'Contraseña actual',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmar nueva contraseña',
    subscription: 'Suscripción',
    uploadPhoto: 'Subir foto',
    changePhoto: 'Cambiar foto',
    removePhoto: 'Eliminar foto',
    darkMode: 'Modo oscuro',
    language: 'Idioma',
    appearance: 'Apariencia e idioma',
    success: 'Éxito',
    error: 'Error',
    loading: 'Cargando...',
    saving: 'Guardando...',
    deleting: 'Eliminando...',
    confirmDelete: '¿Estás seguro de eliminar esto?',
    profileUpdated: '¡Perfil actualizado correctamente!',
    passwordChanged: '¡Contraseña cambiada correctamente!',
    passwordMismatch: 'Las nuevas contraseñas no coinciden',
    passwordShort: 'La contraseña debe tener al menos 12 caracteres',
  },

  ur: {
    appName: 'سینئر کیئر',
    hello: 'ہیلو',
    appointments: 'ملاقاتیں',
    settings: 'ترتیبات',
    logout: 'لاگ آؤٹ',
    notifications: 'اطلاعات',
    noNotifications: 'کوئی اطلاع نہیں',
    markAllRead: 'سب پڑھا ہوا نشان کریں',
    clearAll: 'تمام اطلاعات صاف کریں',
    dashboard: 'ڈیش بورڈ',
    addSenior: 'بزرگ شامل کریں',
    addCaregiver: 'نگہداشت کار شامل کریں',
    seniors: 'بزرگ',
    caregivers: 'نگہداشت کار',
    totalSeniors: 'کل بزرگ',
    totalCaregivers: 'کل نگہداشت کار',
    totalMedications: 'کل دوائیں',
    todayAppointments: 'آج کی ملاقاتیں',
    name: 'نام',
    age: 'عمر',
    phone: 'فون',
    photo: 'تصویر',
    edit: 'ترمیم',
    delete: 'حذف',
    save: 'محفوظ کریں',
    cancel: 'منسوخ',
    confirm: 'تصدیق',
    view: 'دیکھیں',
    close: 'بند کریں',
    medications: 'دوائیں',
    vitals: 'اہم علامات',
    journal: 'روزنامچہ',
    addMedication: 'دوا شامل کریں',
    medicationName: 'دوا کا نام',
    dose: 'خوراک',
    frequency: 'تکرار',
    time: 'وقت',
    notes: 'نوٹس',
    logDose: 'خوراک ریکارڈ کریں',
    sosAlert: 'SOS انتباہ',
    sendSos: 'SOS بھیجیں',
    pdfReport: 'PDF رپورٹ',
    emailReport: 'ای میل رپورٹ',
    bloodPressure: 'بلڈ پریشر',
    heartRate: 'دل کی دھڑکن',
    weight: 'وزن',
    glucose: 'گلوکوز',
    addVital: 'قدر شامل کریں',
    addJournalEntry: 'اندراج شامل کریں',
    journalEntry: 'روزانہ اندراج',
    allAppointments: 'تمام ملاقاتیں',
    upcoming: 'آنے والی',
    completed: 'مکمل',
    addAppointment: 'ملاقات شامل کریں',
    appointmentTitle: 'عنوان',
    appointmentDate: 'تاریخ',
    appointmentTime: 'وقت',
    appointmentType: 'قسم',
    doctor: 'ڈاکٹر',
    bloodTest: 'خون کا ٹیسٹ',
    checkup: 'چیک اپ',
    other: 'دیگر',
    recurring: 'بار بار',
    repeatEvery: 'ہر بار دہرائیں',
    days: 'دن',
    weeks: 'ہفتے',
    markComplete: 'مکمل نشان کریں',
    addResults: 'نتائج شامل کریں',
    results: 'نتائج',
    listView: 'فہرست',
    calendarView: 'کیلنڈر',
    assignedCaregivers: 'مقرر نگہداشت کار',
    assignCaregiver: 'نگہداشت کار مقرر کریں',
    removeAssignment: 'ہٹائیں',
    noAssignments: 'ابھی تک کوئی نگہداشت کار مقرر نہیں',
    profile: 'پروفائل',
    fullName: 'پورا نام',
    email: 'ای میل',
    saveProfile: 'پروفائل محفوظ کریں',
    changePassword: 'پاس ورڈ تبدیل کریں',
    currentPassword: 'موجودہ پاس ورڈ',
    newPassword: 'نیا پاس ورڈ',
    confirmPassword: 'نئے پاس ورڈ کی تصدیق',
    subscription: 'سبسکرپشن',
    uploadPhoto: 'تصویر اپ لوڈ کریں',
    changePhoto: 'تصویر تبدیل کریں',
    removePhoto: 'تصویر ہٹائیں',
    darkMode: 'ڈارک موڈ',
    language: 'زبان',
    appearance: 'ظاہری شکل اور زبان',
    success: 'کامیابی',
    error: 'خرابی',
    loading: 'لوڈ ہو رہا ہے...',
    saving: 'محفوظ ہو رہا ہے...',
    deleting: 'حذف ہو رہا ہے...',
    confirmDelete: 'کیا آپ واقعی اسے حذف کرنا چاہتے ہیں؟',
    profileUpdated: 'پروفائل کامیابی سے اپ ڈیٹ ہو گئی!',
    passwordChanged: 'پاس ورڈ کامیابی سے تبدیل ہو گیا!',
    passwordMismatch: 'نئے پاس ورڈ مطابقت نہیں رکھتے',
    passwordShort: 'پاس ورڈ کم از کم 12 حروف کا ہونا چاہیے',
  },

  zh: {
    appName: '长者关爱',
    hello: '你好',
    appointments: '预约',
    settings: '设置',
    logout: '退出',
    notifications: '通知',
    noNotifications: '暂无通知',
    markAllRead: '全部标为已读',
    clearAll: '清除所有通知',
    dashboard: '仪表板',
    addSenior: '添加老人',
    addCaregiver: '添加护工',
    seniors: '老人',
    caregivers: '护工',
    totalSeniors: '老人总数',
    totalCaregivers: '护工总数',
    totalMedications: '药物总数',
    todayAppointments: '今日预约',
    name: '姓名',
    age: '年龄',
    phone: '电话',
    photo: '照片',
    edit: '编辑',
    delete: '删除',
    save: '保存',
    cancel: '取消',
    confirm: '确认',
    view: '查看',
    close: '关闭',
    medications: '药物',
    vitals: '生命体征',
    journal: '日记',
    addMedication: '添加药物',
    medicationName: '药物名称',
    dose: '剂量',
    frequency: '频率',
    time: '时间',
    notes: '备注',
    logDose: '记录用药',
    sosAlert: 'SOS 警报',
    sendSos: '发送 SOS',
    pdfReport: 'PDF 报告',
    emailReport: '邮件报告',
    bloodPressure: '血压',
    heartRate: '心率',
    weight: '体重',
    glucose: '血糖',
    addVital: '添加体征',
    addJournalEntry: '添加日记',
    journalEntry: '日记条目',
    allAppointments: '所有预约',
    upcoming: '即将到来',
    completed: '已完成',
    addAppointment: '添加预约',
    appointmentTitle: '标题',
    appointmentDate: '日期',
    appointmentTime: '时间',
    appointmentType: '类型',
    doctor: '医生',
    bloodTest: '血液检查',
    checkup: '体检',
    other: '其他',
    recurring: '定期重复',
    repeatEvery: '每隔',
    days: '天',
    weeks: '周',
    markComplete: '标记完成',
    addResults: '添加结果',
    results: '结果',
    listView: '列表',
    calendarView: '日历',
    assignedCaregivers: '已分配护工',
    assignCaregiver: '分配护工',
    removeAssignment: '移除',
    noAssignments: '尚未分配护工',
    profile: '个人资料',
    fullName: '全名',
    email: '电子邮件',
    saveProfile: '保存资料',
    changePassword: '更改密码',
    currentPassword: '当前密码',
    newPassword: '新密码',
    confirmPassword: '确认新密码',
    subscription: '订阅',
    uploadPhoto: '上传照片',
    changePhoto: '更换照片',
    removePhoto: '删除照片',
    darkMode: '深色模式',
    language: '语言',
    appearance: '外观与语言',
    success: '成功',
    error: '错误',
    loading: '加载中...',
    saving: '保存中...',
    deleting: '删除中...',
    confirmDelete: '确定要删除吗？',
    profileUpdated: '个人资料更新成功！',
    passwordChanged: '密码更改成功！',
    passwordMismatch: '两次密码不一致',
    passwordShort: '密码至少需要12个字符',
  },

  ja: {
    appName: 'シニアケア',
    hello: 'こんにちは',
    appointments: '予約',
    settings: '設定',
    logout: 'ログアウト',
    notifications: '通知',
    noNotifications: '通知はありません',
    markAllRead: 'すべて既読にする',
    clearAll: '通知をすべて消去',
    dashboard: 'ダッシュボード',
    addSenior: '高齢者を追加',
    addCaregiver: '介護者を追加',
    seniors: '高齢者',
    caregivers: '介護者',
    totalSeniors: '高齢者合計',
    totalCaregivers: '介護者合計',
    totalMedications: '薬合計',
    todayAppointments: '本日の予約',
    name: '名前',
    age: '年齢',
    phone: '電話',
    photo: '写真',
    edit: '編集',
    delete: '削除',
    save: '保存',
    cancel: 'キャンセル',
    confirm: '確認',
    view: '表示',
    close: '閉じる',
    medications: '薬',
    vitals: 'バイタルサイン',
    journal: '日誌',
    addMedication: '薬を追加',
    medicationName: '薬の名前',
    dose: '用量',
    frequency: '頻度',
    time: '時間',
    notes: 'メモ',
    logDose: '服薬を記録',
    sosAlert: 'SOS アラート',
    sendSos: 'SOS を送信',
    pdfReport: 'PDF レポート',
    emailReport: 'メールレポート',
    bloodPressure: '血圧',
    heartRate: '心拍数',
    weight: '体重',
    glucose: '血糖値',
    addVital: 'バイタルを追加',
    addJournalEntry: '日誌を追加',
    journalEntry: '日誌エントリ',
    allAppointments: 'すべての予約',
    upcoming: '予定',
    completed: '完了',
    addAppointment: '予約を追加',
    appointmentTitle: 'タイトル',
    appointmentDate: '日付',
    appointmentTime: '時間',
    appointmentType: '種類',
    doctor: '医師',
    bloodTest: '血液検査',
    checkup: '健康診断',
    other: 'その他',
    recurring: '定期的',
    repeatEvery: '繰り返し間隔',
    days: '日',
    weeks: '週',
    markComplete: '完了にする',
    addResults: '結果を追加',
    results: '結果',
    listView: 'リスト',
    calendarView: 'カレンダー',
    assignedCaregivers: '担当介護者',
    assignCaregiver: '介護者を割り当て',
    removeAssignment: '解除',
    noAssignments: 'まだ介護者が割り当てられていません',
    profile: 'プロフィール',
    fullName: '氏名',
    email: 'メールアドレス',
    saveProfile: 'プロフィールを保存',
    changePassword: 'パスワードを変更',
    currentPassword: '現在のパスワード',
    newPassword: '新しいパスワード',
    confirmPassword: '新しいパスワードの確認',
    subscription: 'サブスクリプション',
    uploadPhoto: '写真をアップロード',
    changePhoto: '写真を変更',
    removePhoto: '写真を削除',
    darkMode: 'ダークモード',
    language: '言語',
    appearance: '外観と言語',
    success: '成功',
    error: 'エラー',
    loading: '読み込み中...',
    saving: '保存中...',
    deleting: '削除中...',
    confirmDelete: '本当に削除しますか？',
    profileUpdated: 'プロフィールを更新しました！',
    passwordChanged: 'パスワードを変更しました！',
    passwordMismatch: '新しいパスワードが一致しません',
    passwordShort: 'パスワードは12文字以上必要です',
  },

  tl: {
    appName: 'SeniorCare',
    hello: 'Kumusta',
    appointments: 'Mga Appointment',
    settings: 'Mga Setting',
    logout: 'Mag-logout',
    notifications: 'Mga Notification',
    noNotifications: 'Wala pang notification',
    markAllRead: 'Markahan lahat na nabasa',
    clearAll: 'Burahin lahat ng notification',
    dashboard: 'Dashboard',
    addSenior: 'Magdagdag ng Matanda',
    addCaregiver: 'Magdagdag ng Tagapag-alaga',
    seniors: 'Mga Matanda',
    caregivers: 'Mga Tagapag-alaga',
    totalSeniors: 'Kabuuang Matanda',
    totalCaregivers: 'Kabuuang Tagapag-alaga',
    totalMedications: 'Kabuuang Gamot',
    todayAppointments: 'Appointment Ngayon',
    name: 'Pangalan',
    age: 'Edad',
    phone: 'Telepono',
    photo: 'Larawan',
    edit: 'I-edit',
    delete: 'Burahin',
    save: 'I-save',
    cancel: 'Kanselahin',
    confirm: 'Kumpirmahin',
    view: 'Tingnan',
    close: 'Isara',
    medications: 'Mga Gamot',
    vitals: 'Mga Vital Signs',
    journal: 'Journal',
    addMedication: 'Magdagdag ng Gamot',
    medicationName: 'Pangalan ng Gamot',
    dose: 'Dosis',
    frequency: 'Dalas',
    time: 'Oras',
    notes: 'Mga Tala',
    logDose: 'I-record ang Dosis',
    sosAlert: 'SOS Alerto',
    sendSos: 'Magpadala ng SOS',
    pdfReport: 'PDF na Ulat',
    emailReport: 'Email na Ulat',
    bloodPressure: 'Presyon ng Dugo',
    heartRate: 'Rate ng Puso',
    weight: 'Timbang',
    glucose: 'Asukal sa Dugo',
    addVital: 'Magdagdag ng Vital',
    addJournalEntry: 'Magdagdag ng Entry',
    journalEntry: 'Entry sa Journal',
    allAppointments: 'Lahat ng Appointment',
    upcoming: 'Paparating',
    completed: 'Natapos na',
    addAppointment: 'Magdagdag ng Appointment',
    appointmentTitle: 'Pamagat',
    appointmentDate: 'Petsa',
    appointmentTime: 'Oras',
    appointmentType: 'Uri',
    doctor: 'Doktor',
    bloodTest: 'Pagsusuri ng Dugo',
    checkup: 'Check-up',
    other: 'Iba pa',
    recurring: 'Paulit-ulit',
    repeatEvery: 'Ulitin tuwing',
    days: 'araw',
    weeks: 'linggo',
    markComplete: 'Markahan Natapos',
    addResults: 'Magdagdag ng Resulta',
    results: 'Mga Resulta',
    listView: 'Listahan',
    calendarView: 'Kalendaryo',
    assignedCaregivers: 'Mga Nakatalagang Tagapag-alaga',
    assignCaregiver: 'Mag-assign ng Tagapag-alaga',
    removeAssignment: 'Alisin',
    noAssignments: 'Wala pang nakatalagang tagapag-alaga',
    profile: 'Profile',
    fullName: 'Buong Pangalan',
    email: 'Email',
    saveProfile: 'I-save ang Profile',
    changePassword: 'Baguhin ang Password',
    currentPassword: 'Kasalukuyang Password',
    newPassword: 'Bagong Password',
    confirmPassword: 'Kumpirmahin ang Bagong Password',
    subscription: 'Subscription',
    uploadPhoto: 'Mag-upload ng Larawan',
    changePhoto: 'Palitan ang Larawan',
    removePhoto: 'Alisin ang Larawan',
    darkMode: 'Dark Mode',
    language: 'Wika',
    appearance: 'Hitsura at Wika',
    success: 'Tagumpay',
    error: 'Error',
    loading: 'Naglo-load...',
    saving: 'Sine-save...',
    deleting: 'Binubura...',
    confirmDelete: 'Sigurado ka bang gusto mong burahin ito?',
    profileUpdated: 'Matagumpay na na-update ang profile!',
    passwordChanged: 'Matagumpay na nabago ang password!',
    passwordMismatch: 'Hindi magkapareho ang mga bagong password',
    passwordShort: 'Ang password ay dapat may hindi bababa sa 12 na karakter',
  },

  hi: {
    appName: 'सीनियरकेयर',
    hello: 'नमस्ते',
    appointments: 'अपॉइंटमेंट',
    settings: 'सेटिंग्स',
    logout: 'लॉग आउट',
    notifications: 'सूचनाएं',
    noNotifications: 'अभी कोई सूचना नहीं',
    markAllRead: 'सभी को पढ़ा हुआ चिह्नित करें',
    clearAll: 'सभी सूचनाएं साफ करें',
    dashboard: 'डैशबोर्ड',
    addSenior: 'बुजुर्ग जोड़ें',
    addCaregiver: 'देखभालकर्ता जोड़ें',
    seniors: 'बुजुर्ग',
    caregivers: 'देखभालकर्ता',
    totalSeniors: 'कुल बुजुर्ग',
    totalCaregivers: 'कुल देखभालकर्ता',
    totalMedications: 'कुल दवाइयां',
    todayAppointments: 'आज के अपॉइंटमेंट',
    name: 'नाम',
    age: 'उम्र',
    phone: 'फोन',
    photo: 'फोटो',
    edit: 'संपादित करें',
    delete: 'हटाएं',
    save: 'सहेजें',
    cancel: 'रद्द करें',
    confirm: 'पुष्टि करें',
    view: 'देखें',
    close: 'बंद करें',
    medications: 'दवाइयां',
    vitals: 'स्वास्थ्य संकेत',
    journal: 'डायरी',
    addMedication: 'दवाई जोड़ें',
    medicationName: 'दवाई का नाम',
    dose: 'खुराक',
    frequency: 'बार-बार',
    time: 'समय',
    notes: 'नोट्स',
    logDose: 'खुराक दर्ज करें',
    sosAlert: 'SOS अलर्ट',
    sendSos: 'SOS भेजें',
    pdfReport: 'PDF रिपोर्ट',
    emailReport: 'ईमेल रिपोर्ट',
    bloodPressure: 'रक्तचाप',
    heartRate: 'हृदय गति',
    weight: 'वजन',
    glucose: 'रक्त शर्करा',
    addVital: 'संकेत जोड़ें',
    addJournalEntry: 'डायरी लिखें',
    journalEntry: 'डायरी प्रविष्टि',
    allAppointments: 'सभी अपॉइंटमेंट',
    upcoming: 'आगामी',
    completed: 'पूर्ण',
    addAppointment: 'अपॉइंटमेंट जोड़ें',
    appointmentTitle: 'शीर्षक',
    appointmentDate: 'तारीख',
    appointmentTime: 'समय',
    appointmentType: 'प्रकार',
    doctor: 'डॉक्टर',
    bloodTest: 'रक्त परीक्षण',
    checkup: 'स्वास्थ्य जांच',
    other: 'अन्य',
    recurring: 'बार-बार होने वाला',
    repeatEvery: 'हर बार दोहराएं',
    days: 'दिन',
    weeks: 'सप्ताह',
    markComplete: 'पूर्ण चिह्नित करें',
    addResults: 'परिणाम जोड़ें',
    results: 'परिणाम',
    listView: 'सूची',
    calendarView: 'कैलेंडर',
    assignedCaregivers: 'नियुक्त देखभालकर्ता',
    assignCaregiver: 'देखभालकर्ता नियुक्त करें',
    removeAssignment: 'हटाएं',
    noAssignments: 'अभी कोई देखभालकर्ता नियुक्त नहीं',
    profile: 'प्रोफाइल',
    fullName: 'पूरा नाम',
    email: 'ईमेल',
    saveProfile: 'प्रोफाइल सहेजें',
    changePassword: 'पासवर्ड बदलें',
    currentPassword: 'वर्तमान पासवर्ड',
    newPassword: 'नया पासवर्ड',
    confirmPassword: 'नए पासवर्ड की पुष्टि करें',
    subscription: 'सदस्यता',
    uploadPhoto: 'फोटो अपलोड करें',
    changePhoto: 'फोटो बदलें',
    removePhoto: 'फोटो हटाएं',
    darkMode: 'डार्क मोड',
    language: 'भाषा',
    appearance: 'रूप और भाषा',
    success: 'सफलता',
    error: 'त्रुटि',
    loading: 'लोड हो रहा है...',
    saving: 'सहेजा जा रहा है...',
    deleting: 'हटाया जा रहा है...',
    confirmDelete: 'क्या आप वाकई इसे हटाना चाहते हैं?',
    profileUpdated: 'प्रोफाइल सफलतापूर्वक अपडेट हो गई!',
    passwordChanged: 'पासवर्ड सफलतापूर्वक बदल गया!',
    passwordMismatch: 'नए पासवर्ड मेल नहीं खाते',
    passwordShort: 'पासवर्ड कम से कम 12 अक्षर का होना चाहिए',
  },

  pa: {
    appName: 'ਸੀਨੀਅਰਕੇਅਰ',
    hello: 'ਸਤ ਸ੍ਰੀ ਅਕਾਲ',
    appointments: 'ਮੁਲਾਕਾਤਾਂ',
    settings: 'ਸੈਟਿੰਗਾਂ',
    logout: 'ਲੌਗ ਆਉਟ',
    notifications: 'ਸੂਚਨਾਵਾਂ',
    noNotifications: 'ਹੁਣੇ ਕੋਈ ਸੂਚਨਾ ਨਹੀਂ',
    markAllRead: 'ਸਭ ਪੜ੍ਹੀਆਂ ਹੋਈਆਂ ਨਿਸ਼ਾਨ ਕਰੋ',
    clearAll: 'ਸਾਰੀਆਂ ਸੂਚਨਾਵਾਂ ਸਾਫ਼ ਕਰੋ',
    dashboard: 'ਡੈਸ਼ਬੋਰਡ',
    addSenior: 'ਬਜ਼ੁਰਗ ਜੋੜੋ',
    addCaregiver: 'ਦੇਖਭਾਲਕਰਤਾ ਜੋੜੋ',
    seniors: 'ਬਜ਼ੁਰਗ',
    caregivers: 'ਦੇਖਭਾਲਕਰਤਾ',
    totalSeniors: 'ਕੁੱਲ ਬਜ਼ੁਰਗ',
    totalCaregivers: 'ਕੁੱਲ ਦੇਖਭਾਲਕਰਤਾ',
    totalMedications: 'ਕੁੱਲ ਦਵਾਈਆਂ',
    todayAppointments: 'ਅੱਜ ਦੀਆਂ ਮੁਲਾਕਾਤਾਂ',
    name: 'ਨਾਮ',
    age: 'ਉਮਰ',
    phone: 'ਫ਼ੋਨ',
    photo: 'ਫ਼ੋਟੋ',
    edit: 'ਸੋਧੋ',
    delete: 'ਮਿਟਾਓ',
    save: 'ਸੁਰੱਖਿਅਤ ਕਰੋ',
    cancel: 'ਰੱਦ ਕਰੋ',
    confirm: 'ਪੁਸ਼ਟੀ ਕਰੋ',
    view: 'ਵੇਖੋ',
    close: 'ਬੰਦ ਕਰੋ',
    medications: 'ਦਵਾਈਆਂ',
    vitals: 'ਸਿਹਤ ਸੰਕੇਤ',
    journal: 'ਡਾਇਰੀ',
    addMedication: 'ਦਵਾਈ ਜੋੜੋ',
    medicationName: 'ਦਵਾਈ ਦਾ ਨਾਮ',
    dose: 'ਖੁਰਾਕ',
    frequency: 'ਵਾਰ-ਵਾਰ',
    time: 'ਸਮਾਂ',
    notes: 'ਨੋਟਸ',
    logDose: 'ਖੁਰਾਕ ਦਰਜ ਕਰੋ',
    sosAlert: 'SOS ਚੇਤਾਵਨੀ',
    sendSos: 'SOS ਭੇਜੋ',
    pdfReport: 'PDF ਰਿਪੋਰਟ',
    emailReport: 'ਈਮੇਲ ਰਿਪੋਰਟ',
    bloodPressure: 'ਬਲੱਡ ਪ੍ਰੈਸ਼ਰ',
    heartRate: 'ਦਿਲ ਦੀ ਧੜਕਣ',
    weight: 'ਭਾਰ',
    glucose: 'ਬਲੱਡ ਸ਼ੂਗਰ',
    addVital: 'ਸੰਕੇਤ ਜੋੜੋ',
    addJournalEntry: 'ਡਾਇਰੀ ਲਿਖੋ',
    journalEntry: 'ਡਾਇਰੀ ਐਂਟਰੀ',
    allAppointments: 'ਸਾਰੀਆਂ ਮੁਲਾਕਾਤਾਂ',
    upcoming: 'ਆਉਣ ਵਾਲੀਆਂ',
    completed: 'ਮੁਕੰਮਲ',
    addAppointment: 'ਮੁਲਾਕਾਤ ਜੋੜੋ',
    appointmentTitle: 'ਸਿਰਲੇਖ',
    appointmentDate: 'ਤਾਰੀਖ਼',
    appointmentTime: 'ਸਮਾਂ',
    appointmentType: 'ਕਿਸਮ',
    doctor: 'ਡਾਕਟਰ',
    bloodTest: 'ਖ਼ੂਨ ਦੀ ਜਾਂਚ',
    checkup: 'ਸਿਹਤ ਜਾਂਚ',
    other: 'ਹੋਰ',
    recurring: 'ਵਾਰ-ਵਾਰ',
    repeatEvery: 'ਹਰ ਵਾਰ ਦੁਹਰਾਓ',
    days: 'ਦਿਨ',
    weeks: 'ਹਫ਼ਤੇ',
    markComplete: 'ਮੁਕੰਮਲ ਨਿਸ਼ਾਨ ਕਰੋ',
    addResults: 'ਨਤੀਜੇ ਜੋੜੋ',
    results: 'ਨਤੀਜੇ',
    listView: 'ਸੂਚੀ',
    calendarView: 'ਕੈਲੰਡਰ',
    assignedCaregivers: 'ਨਿਯੁਕਤ ਦੇਖਭਾਲਕਰਤਾ',
    assignCaregiver: 'ਦੇਖਭਾਲਕਰਤਾ ਨਿਯੁਕਤ ਕਰੋ',
    removeAssignment: 'ਹਟਾਓ',
    noAssignments: 'ਹੁਣੇ ਕੋਈ ਦੇਖਭਾਲਕਰਤਾ ਨਿਯੁਕਤ ਨਹੀਂ',
    profile: 'ਪ੍ਰੋਫਾਈਲ',
    fullName: 'ਪੂਰਾ ਨਾਮ',
    email: 'ਈਮੇਲ',
    saveProfile: 'ਪ੍ਰੋਫਾਈਲ ਸੁਰੱਖਿਅਤ ਕਰੋ',
    changePassword: 'ਪਾਸਵਰਡ ਬਦਲੋ',
    currentPassword: 'ਮੌਜੂਦਾ ਪਾਸਵਰਡ',
    newPassword: 'ਨਵਾਂ ਪਾਸਵਰਡ',
    confirmPassword: 'ਨਵੇਂ ਪਾਸਵਰਡ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ',
    subscription: 'ਸਬਸਕ੍ਰਿਪਸ਼ਨ',
    uploadPhoto: 'ਫ਼ੋਟੋ ਅਪਲੋਡ ਕਰੋ',
    changePhoto: 'ਫ਼ੋਟੋ ਬਦਲੋ',
    removePhoto: 'ਫ਼ੋਟੋ ਹਟਾਓ',
    darkMode: 'ਡਾਰਕ ਮੋਡ',
    language: 'ਭਾਸ਼ਾ',
    appearance: 'ਰੂਪ ਅਤੇ ਭਾਸ਼ਾ',
    success: 'ਸਫਲਤਾ',
    error: 'ਗਲਤੀ',
    loading: 'ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ...',
    saving: 'ਸੁਰੱਖਿਅਤ ਹੋ ਰਿਹਾ ਹੈ...',
    deleting: 'ਮਿਟਾਇਆ ਜਾ ਰਿਹਾ ਹੈ...',
    confirmDelete: 'ਕੀ ਤੁਸੀਂ ਸੱਚਮੁੱਚ ਇਸਨੂੰ ਮਿਟਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ?',
    profileUpdated: 'ਪ੍ਰੋਫਾਈਲ ਸਫਲਤਾਪੂਰਵਕ ਅਪਡੇਟ ਹੋ ਗਈ!',
    passwordChanged: 'ਪਾਸਵਰਡ ਸਫਲਤਾਪੂਰਵਕ ਬਦਲ ਗਿਆ!',
    passwordMismatch: 'ਨਵੇਂ ਪਾਸਵਰਡ ਮੇਲ ਨਹੀਂ ਖਾਂਦੇ',
    passwordShort: 'ਪਾਸਵਰਡ ਘੱਟੋ-ਘੱਟ 12 ਅੱਖਰਾਂ ਦਾ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ',
  },
};

export function t(lang, key) {
  return (translations[lang] && translations[lang][key]) || translations['en'][key] || key;
}

export const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'ar', label: 'العربية' },
  { code: 'fr', label: 'Français' },
  { code: 'es', label: 'Español' },
  { code: 'ur', label: 'اردو' },
  { code: 'zh', label: '中文' },
  { code: 'ja', label: '日本語' },
  { code: 'tl', label: 'Filipino' },
  { code: 'hi', label: 'हिंदी' },
  { code: 'pa', label: 'ਪੰਜਾਬੀ' },
];

export default translations;
